import { useContext } from "react";
import { ApiContext } from "../../contexts/ApiContext";
import { useMutation } from "react-query";
import { QueryCallbacks } from "../../shared/interfaces/ReactQuery";
import { NewReusableCustomQuestionField } from "../../shared/interfaces/ReusableCustomQuestionField";

export function useCustomQuestionFieldCreate(callbacks?: QueryCallbacks<number>) {
  const apiContext = useContext(ApiContext);
  return useMutation(
    ["customQuestionFieldCreate"],
    async (customQuestionField: NewReusableCustomQuestionField) =>
      apiContext.customWorkflowQuestionApis.createCustomQuestionField(customQuestionField),
    {
      onSuccess: callbacks?.onSuccess,
      onError: callbacks?.onError,
    },
  );
}
